import {makeStyles} from "@material-ui/core/styles";

export const  useStyles = makeStyles((theme) => ({
    root:{
        width: '100%',
        minHeight: 'calc(100vh - 54px)',
        marginTop: 54,
        padding: 24,
        boxSizing: 'border-box'
    },
    tableBox:{
        borderRadius: '8px 8px 0 0',
        boxShadow: 'none',
        background:'#fff',
        '&::-webkit-scrollbar': {
            width: '10px',
            height: '10px'
        },
        '&::-webkit-scrollbar-thumb': {
            background: '#6f6f6f',
            borderRadius: '10px',
            backgroundClip: 'padding-box',
            border: '3px solid transparent',
        },
        '&::-webkit-scrollbar-track': {
            background: 'transparent',
            marginTop: 5,
        },
    },
    table: {
        minWidth: 930,
        overflowX:'auto',
    },
    tableHeadStyle:{
        '& th':{
            height: 50,
            padding: '0 10px',
            fontSize: '1rem',
            fontWeight: 700,
            color: '#10121C',
            borderBottom: '1px solid #BCBCBC'
        }
    },
    tableBodyStyle:{
        '& th, td':{
            padding: '13px 10px',
            fontSize: '1rem',
            fontWeight: 400,
            color: '#10121C',
            borderBottom: '1px solid #BCBCBC'
        },
        '& th':{
            fontWeight: 700,
        },
    },
    tableButton:{
        width: 80,
        height:30,
        borderRadius: 4,
        background: '#5579F0',
        padding: 0,
        color: '#fff',
        fontSize: '1rem',
        fontWeight: 700,
        '&:hover':{
            background:'#5579F0'
        }
    },
    sortButton:{
        cursor:'pointer',
        display:'flex',
        alignItems: 'center',
        '& p':{
            fontSize: '1rem',
            fontWeight: 700,
            color: '#10121C',
            marginRight: 4,
            marginLeft: 10,
        }
    },
    paginationBox:{
        '& .MuiToolbar-root':{
            position: 'relative',
        },
        '& .MuiInputBase-root':{
            marginLeft: 0,
            marginRight: 20
        },
        '& .MuiSelect-select':{
            fontSize: '0.75rem',
            color:'#323232',
            paddingRight: 17,
            '&:focus':{
                background:'transparent'
            }
        },
        '& .MuiTablePagination-caption':{
            fontSize: '0.75rem',
            color: '#10121c',
            fontWeight: 400
        },
        '& .MuiTablePagination-selectLabel':{
            fontSize: '0.75rem',
            color:'#323232',
        },
        '& .MuiTablePagination-selectRoot':{
            '& svg':{
                marginTop: 3
            }
        },
        '& button':{
            padding:0,
            '&:hover':{
                background:'transparent'
            },
        }
    },
    displayRow:{
        '& span':{
            fontWeight: '700 !important'
        }
    },
    selectPopover:{
        '& .MuiPaper-root':{
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
            border: '1px solid #bbb',
            boxSizing:'border-box',
            '& *': {
                fontFamily: 'Pretendard !important',
            },
        },
        '& .MuiMenuItem-root':{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '0.875rem',
            color:'#323232',
            padding: '0 12px',
            boxSizing: 'border-box',
            height: 28,
            '&:hover':{
                background: '#eee'
            },
            '&.Mui-selected':{
                background: '#eee'
            },
            '&.Mui-disabled': {
                opacity: 1,
                '& svg':{
                    pointerEvents: 'auto'
                }
            },
        }
    },
    tabBox: {
        position: 'relative',
        '& .MuiTabs-root':{
            minHeight: 40,
        },
        '& .MuiTab-root':{
            minWidth: 70,
        },
        '& .MuiTabs-flexContainer': {
            // width: 248,
            borderBottom: '1px solid #bbbbbb',
            borderRadius: 0,
            overflow: 'hidden'
        },
        '& button': {
            width: 160,
            minHeight: 48,
            height: 48,
            position: 'relative',
            fontSize: '1.063rem',
            fontWeight: 500,
            letterSpacing: '-0.5px',
            color:'#323232',
            boxSizing: 'border-box',
            padding:0,
        },
        '& button.Mui-selected': {
            fontWeight: 600,
            color: '#000',
            opacity: 1,
            boxSizing: 'border-box',
            background: 'transparent',
            borderRadius: 0
        },
        '& .MuiTabs-indicator':{
            height: 3,
            paddingBottom: 0,
            backgroundColor: '#000'
        },
        '& .MuiTab-wrapper': {
            alignItems: 'flex-start',
            paddingLeft: 10,
        }
    },
    buttonStyle:{
        '&.MuiButtonBase-root': {
            width: 180,
            height: 36,
            padding: 0,
            minHeight: 36,
            background: '#5579F0',
            borderRadius: 4,
            marginLeft: 10,
            boxSizing: 'border-box',
            '&:hover':{
                background: '#5579F0',
            },
            '& p':{
                fontSize: '0.875rem',
                color: '#fff',
                fontWeight: 700,
                marginLeft: 8
            },
            '&.Mui-disabled':{
                background: 'rgba(16, 18, 28, 0.30)',
                '& p':{
                    color: 'rgba(255, 255, 255, 0.70)'
                },
                '& path':{
                    stroke:'rgba(255, 255, 255, 0.70)'
                }
            }
        }
    },
    buttonStyle3:{
        '&.MuiButtonBase-root': {
            width: 70,
            background: '#10121C',
            marginLeft: 16,
            '& p':{
                marginLeft: 0
            },
            '&:hover':{
                background: '#10121C',
            },
        }
    },
    formControl:{
        '&.MuiFormControl-root ':{
            margin: 0,
        },
        '& .MuiSelect-select':{
            width: 130,
            height: 36,
            padding: '14px 25px 15px 12px !important',
            fontSize: '1.125rem',
            boxSizing:'border-box',
            color:'#777',
            letterSpacing: '-0.5px',
            display:'flex',
            alignItems: 'center',
            background: '#fff',
            border: 'solid 1px rgba(50, 50, 50, 0.8)',
            borderRadius: '6px !important',
            '@media all and (max-width: 800px)': {
                width: '100%',
            },
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiSelect-select':{
            border: '0px solid rgba(117, 0, 250, 0.4)',
            padding: '13px 25px 14px 12px !important',
        },
        '& .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline':{
            border: 0,
            borderRadius: 6,
        },
        '& .MuiInput-underline:after, .MuiInput-underline:before': {
            border: 0,
        },
        '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            border: 0,
        },
        '& .MuiSelect-icon': {
            top: 10,
            right: 6,
        }
    },
    formControl2:{
        '& .MuiSelect-select':{
            marginLeft: 15,
            width: 240,
        },
    },
    textQuizBox: {
        marginLeft: 15,
        '& .MuiFormControl-root': {
            width: 240,
            height: 36,
            boxSizing: 'border-box',
            background: '#fff',
        },
        '& .MuiOutlinedInput-root': {
            height: 40
        },
        '& .MuiOutlinedInput-input': {
            padding: '9px 10px',
        }
    },
    searchBox: {
        margin: '20px 0px'
    },
}));